import _ from 'lodash';

import getCompositionsStore from 'actions/customer/lib/get_compositions_store';

export default class RemoveCompositionError {
  constructor(context) {
    this.context = context;
  }

  run({ attr, compositionId }) {
    const compositionsStore = getCompositionsStore(this.context);
    if (!compositionsStore || !compositionsStore.has({ id: compositionId })) return;

    const errors = compositionsStore.getErrors(compositionId);
    if (errors.length === 0) return;

    const filtered = _.filter(errors, err => err.attr !== attr);
    compositionsStore.setErrors(compositionId, filtered);
  }
}
